import React, { useState } from 'react';
import './GalleryLightbox.css';

const GalleryLightbox = ({ post, onClose }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [copied, setCopied] = useState(false);

  if (!post) return null;

  const images = post.images || [];
  const hasMultiple = images.length > 1;

  const showPrev = () => setActiveIndex((i) => (i === 0 ? images.length - 1 : i - 1));
  const showNext = () => setActiveIndex((i) => (i === images.length - 1 ? 0 : i + 1));

  const handleCopyLink = async () => {
    // The app uses HashRouter — a real link needs the #/ prefix or it 404s.
    const url = `${window.location.origin}/#/gallery/${post.id}`;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('Copy this link:', url);
    }
  };

  const formattedDate = post.createdAt
    ? new Date(post.createdAt).toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })
    : null;

  return (
    <div className="gallery-lightbox-backdrop" onClick={onClose} role="presentation">
      <div className="gallery-lightbox" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="gallery-lightbox__close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="gallery-lightbox__image-area">
          {hasMultiple && (
            <button type="button" className="gallery-lightbox__arrow gallery-lightbox__arrow--left" onClick={showPrev} aria-label="Previous image">
              ‹
            </button>
          )}
          {images[activeIndex] && (
            <img className="gallery-lightbox__main-image" src={images[activeIndex].url} alt={post.caption || 'Gallery photo'} />
          )}
          {hasMultiple && (
            <button type="button" className="gallery-lightbox__arrow gallery-lightbox__arrow--right" onClick={showNext} aria-label="Next image">
              ›
            </button>
          )}
        </div>

        {hasMultiple && (
          <div className="gallery-lightbox__thumbnails">
            {images.map((img, index) => (
              <button
                type="button"
                key={img.id}
                className={`gallery-lightbox__thumbnail ${index === activeIndex ? 'is-active' : ''}`}
                onClick={() => setActiveIndex(index)}
                aria-label={`View image ${index + 1}`}
              >
                <img src={img.url} alt="" />
              </button>
            ))}
          </div>
        )}

        <div className="gallery-lightbox__details">
          <div className="gallery-lightbox__meta">
            {post.tags?.map((tag) => (
              <span key={tag} className="gallery-lightbox__event-badge">{tag}</span>
            ))}
            {formattedDate && <span className="gallery-lightbox__date">{formattedDate}</span>}
          </div>
          {post.caption && <p className="gallery-lightbox__caption">{post.caption}</p>}
          <button type="button" className="gallery-lightbox__copy-link" onClick={handleCopyLink}>
            {copied ? 'Link copied!' : '🔗 Copy link to this post'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GalleryLightbox;
